module.exports = __webpack_public_path__ + "media/sent.bc11c558.mp4";